
import { Button, Card, Input } from "antd"
import React, { useEffect, useRef, useState } from "react"
import { CopyToClipboard } from "react-copy-to-clipboard"
import Peer from "simple-peer"
import { SocketIO } from "../../services/Text/GlobalText"
import MainLayouts from '../../layouts/MainLayouts';
import { TitleBar } from "../../services/Forms/Forms"
import { dataUser } from "../../services/Cache/Auth"
import _Api from "../../services/Api/_Api"
import getQuery from "../../services/Forms/LyBootstrapt"
import Swal from "sweetalert2"


// const socket = io.connect('http://localhost:9006')

function ProsesKonseling() {
	const [me, setMe] = useState("")
	const [stream, setStream] = useState()
	const [loading, setloading] = useState(false)
	const [receivingCall, setReceivingCall] = useState(false)
	const [caller, setCaller] = useState("")
	const [callerSignal, setCallerSignal] = useState()
	const [callAccepted, setCallAccepted] = useState(false)
	const [idToCall, setIdToCall] = useState("")
	const [callEnded, setCallEnded] = useState(false)
	const [name, setName] = useState("")
	const myVideo = useRef()
	const userVideo = useRef()
	const connectionRef = useRef()

	const konstId = getQuery('konsId')


	useEffect(() => {
		navigator.mediaDevices.getUserMedia({ video: true, audio: true }).then((stream) => {
			setStream(stream)
			myVideo.current.srcObject = stream
		})

		SocketIO.on("me", (id) => {
			setMe(id)
			setloading(true)
			// debugger

			if (id != undefined && id != "") {
				const params = {
					idx: konstId,
					idxkonseling: id
				}
				_Api.get("/update-proses-konseling-id", {params : params}).then(res => {
					setloading(false)

					_Api.get("/get-proses-konseling-id", {params : params}).then(res => {
						setloading(false)
						console.log(res)
						if(res.data.sts == 1)
						setIdToCall(res.data.konseling.callID)
					})
				})

				
			}
		})

		SocketIO.on("callUser", (data) => {
			setReceivingCall(true)
			setCaller(data.from)
			setName(data.name)
			setCallerSignal(data.signal)
		})
	}, [])

	const callUser = (id) => {
		const peer = new Peer({
			initiator: true,
			trickle: false,
			stream: stream
		})
		peer.on("signal", (data) => {
			SocketIO.emit("callUser", {
				userToCall: id,
				signalData: data,
				from: me,
				name: name
			})
		})
		peer.on("stream", (stream) => {

			userVideo.current.srcObject = stream

		})
		SocketIO.on("callAccepted", (signal) => {
			setCallAccepted(true)
			peer.signal(signal)
		})

		connectionRef.current = peer
	}

	const answerCall = () => {
		setCallAccepted(true)
		const peer = new Peer({
			initiator: false,
			trickle: false,
			stream: stream
		})
		peer.on("signal", (data) => {
			SocketIO.emit("answerCall", { signal: data, to: caller })
		})
		peer.on("stream", (stream) => {
			userVideo.current.srcObject = stream
		})

		peer.signal(callerSignal)
		connectionRef.current = peer
	}

	const cobaConfirm = () => {
		// SocketIO.emit("konfirmasipembayaran", {makan : "okkee"})
		SocketIO.emit("refreshArsip", "suksesss")

	}
	const leaveCall = () => {
		setCallEnded(true)
		connectionRef.current.destroy()
	}

	return (
		<MainLayouts>
			<br />
			<TitleBar title="PROSES KONSELING" align="center" />
			{/* <h2 className="text-center"> PROSES KONSELING </h2> */}
			<br />
			<div className="row">

				<div className="col-sm-3">
					{stream && <video playsInline className="shadow w-100" muted ref={myVideo} autoPlay />}
					<h4> {dataUser.user && dataUser.user.namaexternal} </h4>
				</div>
				<div className="col-sm-3">
					{callAccepted && !callEnded ?
						// <video playsInline ref={userVideo} autoPlay style={{ width: "100%", borderRadius: "5px" }} /> : null}
						<video playsInline ref={userVideo} autoPlay className="mobile-call w-100" /> :
						null

						// <div style={{ width: "100%", height: "100%", background: "black", borderRadius: "10px" }}></div> 

					}
					<h4>Nama Pasien</h4>
					{idToCall}
				</div>

				<center>
					{callAccepted && !callEnded ? (
						<Button type="ghost" className="hover" style={{ height: "100px" }} onClick={leaveCall}>
							<img src="/img/akhiri.png" width={40} />

							<br />
							Akhiri
						</Button>
					) : (


						<Button type="ghost" className="hover" style={{ height: "100px" }} onClick={() => callUser(idToCall)}>
							<img src="/img/panggil.png" className="blink_me" width={40} />
							<br />
							Panggil
						</Button>

					)}
					&nbsp;


					<Button type="ghost" className="hover" style={{ height: "100px" }} onClick={answerCall}>
						<img src="/img/jawab.png" className="blink_me" width={40} />
						<br />
						Jawab
					</Button> &nbsp;
					<Button type="ghost" className="hover" style={{ height: "100px" }}>
						<img src="/img/tolak.png" width={40} />
						<br />
						Tolak
					</Button>  &nbsp;

				</center>
				<div className="myId">
					<br />
					<Input
						variant="filled"
						// addonAfter={
						// 	<CopyToClipboard text={me} style={{ marginBottom: "2rem" }}>
						// 		<Button variant="contained" color="primary" >
						// 			Copy ID
						// 		</Button>
						// 	</CopyToClipboard>
						// }
						value={idToCall}
						disabled
						// onChange={(e) => setIdToCall(e.target.value)}
					/>




					{/* <div className="call-button">
						{callAccepted && !callEnded ? (
							<Button variant="contained" color="secondary" onClick={leaveCall}>
								Akhiri Panggilan
							</Button>
						) : (
							<Button color="primary" aria-label="call" onClick={() => callUser(idToCall)}>
								Panggil1
							</Button>
						)}
						{idToCall}
					</div> */}
				</div>
				<div>



					{receivingCall && !callAccepted ? 
					        // Swal.fire({
							// 	icon: "warning",
							// 	title: "Panggilan",
							// 	text: "Ada panggilan video call , ",
							// 	// footer: '<div>Mohon tunggu untuk melakukan konseling ! </div>'
							//   })
					(
						<div className="caller">
							<h1 >{name} MEMANGGIL</h1>
							<Button type="text" onClick={answerCall}>
								<img src="/img/jawab.png" width={40} />
							</Button>
						</div>
					) 
					: null}
				</div>
			</div>
		</MainLayouts>
	)
}

export default ProsesKonseling
